import sha1 from 'sha1';

export default (file, xhr, formData) => {
  const ts = Date.now();

  formData.append(
    'signature',
    sha1(`timestamp=${ts}gvkuIb_jMwA06-IWQjkAvBx_YG4`),
  );
  formData.append('api_key', '163316163855343');
  formData.append('timestamp', ts);
};



// WEBPACK FOOTER //
// ./src/utils/ProcessUploadXhr.js